import { ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';

interface SeoProps {
 title: string;
 description: string;
}

function HeaderTags(props: SeoProps): ReactNode {
 const { title, description } = props;
 return (
  <Helmet>
   {/* Standard metadata tags */}
   <title>{title} - Scale Expert</title>
   <meta name="description" content={description} />
   {/* End standard metadata tags */}
   {/* Facebook tags */}
   <meta property="og:type" content="website" />
   <meta property="og:title" content={title} />
   <meta property="og:description" content={description} />
   {/* End Facebook tags */}
  </Helmet>
 );
}
export default HeaderTags;
